import { createAuth } from '@thehotelsnetwork/vue-auth';
import { createHttpClient } from '@thehotelsnetwork/http-client';

import browserStorage from '../browserStorage';

const env = import.meta.env || {};

const auth = createAuth({
  settings: {
    loginUrl: `${env.VUE_APP_NAKAMA_URL}/login`,
  },
  storage: browserStorage,
  httpClient: createHttpClient({
    baseURL: env.VUE_APP_GATEWAY_API_URL,
  }),
});

export default auth;
